import { render } from "./ResumenTiempoObs.vue?vue&type=template&id=04604bc7&scoped=true"
import script from "./ResumenTiempoObs.vue?vue&type=script&lang=js"
export * from "./ResumenTiempoObs.vue?vue&type=script&lang=js"

import "./ResumenTiempoObs.vue?vue&type=style&index=0&id=04604bc7&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04604bc7"]])

export default __exports__